import type { Ref } from "vue";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

type PasswordValidationError = {
  message: string,
  password: string,
  passwordConfirmation: string,
};

export const useChangePasswordStore = defineStore("feature/authentication/change-password", () => {
  const password = ref("");
  const passwordConfirmation = ref("");
  const passwordValidationError: Ref<PasswordValidationError | undefined> = ref(undefined);

  const isMinimumEightCharacters = computed(() => password.value.length >= 8);
  const hasAtLeastOneLowerCaseCharacter = computed(() => /[a-z]/.test(password.value));
  const hasAtLeastOneUpperCaseCharacter = computed(() => /[A-Z]/.test(password.value));
  const hasAtLeastOneNumber = computed(() => /\d/.test(password.value));
  const hasAtLeastOneSpecialCharacter = computed(() => /[!@#$%^&*()\\_=+{};:,<.>-]/.test(password.value));
  const passwordsMatch = computed(() => password.value === passwordConfirmation.value);

  const passwordMeetsSecurityCriteria = computed(() => {
    return [
      isMinimumEightCharacters.value,
      hasAtLeastOneLowerCaseCharacter.value,
      hasAtLeastOneUpperCaseCharacter.value,
      hasAtLeastOneNumber.value,
      hasAtLeastOneSpecialCharacter.value,
    ].every(value => value);
  });

  return {
    password,
    passwordConfirmation,
    passwordValidationError,

    isMinimumEightCharacters,
    hasAtLeastOneLowerCaseCharacter,
    hasAtLeastOneUpperCaseCharacter,
    hasAtLeastOneNumber,
    hasAtLeastOneSpecialCharacter,
    passwordsMatch,
    passwordMeetsSecurityCriteria,
  };
});
